module.exports = __webpack_public_path__ + "static/wlcac-a395b9f30ca8dffc6661842fa0c96b7f.png";